import baseApi from '@/store/api/baseApi';

export const dashboardApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getActiveDashboardUsers: builder.query({
			query: ({ userTypes = [], roleIds = [] } = {}) => ({
				url: '/dashboard-app-dashboard-card/active-users',
				method: 'GET',
				params: {
					userTypes: userTypes.filter(Boolean),
					roleIds: roleIds.filter(
						(roleId) => roleId !== undefined && roleId !== null && roleId !== ''
					)
				}
			})
		}),
		setDashboardCard: builder.mutation({
			query: ({ requestBody }) => ({
				url: '/dashboard-app-dashboard-card',
				method: 'POST',
				body: requestBody
			})
		}),
		updateDashboardCard: builder.mutation({
			query: ({ id, requestBody }) => ({
				url: `/dashboard-app-dashboard-card/${id}`,
				method: 'PUT',
				body: requestBody
			})
		}),
		getActiveUsers: builder.query({
			query: ({ search = '' } = {}) => ({
				url: `/user/search?isNitexUser=true&isActiveOnly=true&search=${encodeURIComponent(search)}`,
				method: 'GET'
			})
		}),
		getDashboardCardList: builder.query({
			query: () => ({
				url: '/dashboard-app-dashboard-card/list',
				method: 'GET'
			})
		}),
		deleteDashboardCard: builder.mutation({
			query: ({ id }) => ({
				url: `/dashboard-app-dashboard-card/${id}`,
				method: 'DELETE'
			})
		}),
		editWiseCardUsers: builder.query({
			query: ({ id }) => ({
				url: `/dashboard-app-dashboard-card/${id}/active-users`,
				method: 'GET'
			})
		}),
		trackDashboardCardUsage: builder.mutation({
			query: ({ cardId }) => ({
				url: '/dashboard-usage-log/track',
				method: 'POST',
				body: { cardId }
			})
		}),
		getRoleWiseDashboardCards: builder.query({
			query: () => ({
				url: `/dashboard-app-dashboard-card/list/my`,
				method: 'GET'
			})
		})
	})
});

export const {
	useGetActiveDashboardUsersQuery,
	useLazyGetActiveDashboardUsersQuery,
	useSetDashboardCardMutation,
	useUpdateDashboardCardMutation,
	useGetActiveUsersQuery,
	useGetDashboardCardListQuery,
	useDeleteDashboardCardMutation,
	useEditWiseCardUsersQuery,
	useGetRoleWiseDashboardCardsQuery,
	useTrackDashboardCardUsageMutation
} = dashboardApi;
